import { useState, useEffect } from "react";
import GraphicCard from "./GraphicCard";
import { API_URL } from "src/service/config";
import { getRequest } from "src/service/api-services/api-services";
import { Layout } from "@components/index";
import { GraphicApiResponse, IGraphic } from "src/types/graphic";
import { IPaginator } from "src/types";
import PaginatorBtn from "@components/pagination/paginator.button";

function ListGraphicsX() {
  const [currentPage, setCurrentPage] = useState(1);
  const [paginator, setPaginatorData] = useState<IPaginator>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [graphics, setGraphics] = useState<IGraphic[]>([]);
  const [openGraphicCode, setOpenGraphicCode] = useState<string | null>(null);

  const [query, setQuery] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        if (query) params.append("search", query);
        params.append("page", String(currentPage));
        params.append("limit", "50");

        const response = await getRequest<GraphicApiResponse>(
          `${API_URL}/graphics?${params.toString()}`
        );
        setGraphics(response.result.graphics);
        setPaginatorData(response.result.pagination);
        setError(undefined);
      } catch (error) {
        setError(error instanceof Error ? error.message : "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, [query, currentPage]);

  return (
    <Layout>
      <div className="bg-gray-50 min-h-screen py-8">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-extrabold text-center mb-10 text-brand">
            Graphic Assets
          </h1>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
            <input
              className="w-full md:w-1/2 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-brand"
              placeholder="Search for a graphics..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />

            <div className="mb-4">
              <div className="mb-1">
                <button
                  onClick={() =>
                    (window.location.href = `/dashboard/graphics/add`)
                  }
                  className="bg-brand text-white px-4 py-2 rounded-md hover:bg-brand-dark transition"
                >
                  Declear Assets
                </button>
              </div>

              <div className="">
                <button
                  onClick={() =>
                    (window.location.href = `/dashboard/assets/upload`)
                  }
                  className="bg-brand text-white px-4 py-2 rounded-md hover:bg-brand-dark transition"
                >
                  Upload Content
                </button>
              </div>
            </div>
          </div>

          {loading && (
            <p className="text-center text-gray-500">
              Loading graphics assets...
            </p>
          )}

          {!loading && error && (
            <p className="text-center text-red-500">{error}</p>
          )}

          {!loading && !error && graphics.length === 0 && (
            <p className="text-center text-gray-600">No graphics available.</p>
          )}

          {!loading && !error && graphics.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {graphics.map((item, index) => (
                <GraphicCard
                  graphic={item}
                  onGraphicChange={(val) =>
                    setOpenGraphicCode(val ? item.code : null)
                  }
                  IsGraphicSelected={openGraphicCode === item.code}
                />
              ))}
            </div>
          )}
        </div>

        {paginator && !loading && (
          <PaginatorBtn setCurrentPage={setCurrentPage} paginator={paginator} />
        )}
      </div>
    </Layout>
  );
}

export default ListGraphicsX;
